import axiosInterceptor from "../../utils/axiosInterseptor";

export const changePassword = (data) => axiosInterceptor.post(`/admin/changeAdminPassword`, data)